/** Display + search helpers for searchable entity dropdowns */

export function candidateDisplayName(c) {
  if (!c) return '';
  const name = (c.personal?.name || c.contact?.name || c.displayName || c.name || '').trim();
  if (name) return name;
  const email = (c.contact?.email || c.displayEmail || '').trim();
  if (email) return email;
  return c.id || '';
}

export function candidateSearchText(c) {
  return [candidateDisplayName(c), c.contact?.phone, c.displayPhone, c.phone, c.contact?.email, c.displayEmail, c.id]
    .filter(Boolean)
    .join(' ')
    .toLowerCase();
}

export function clientDisplayLabel(c) {
  if (!c) return '';
  const name = (c.name || '').trim() || c.id || '';
  return c.id && name !== c.id ? `${name} (${c.id})` : name;
}

export function clientSearchText(c) {
  const contact = c.contacts?.[0] || {};
  return [c.name, c.id, contact.name, contact.email, contact.phone, c.paymentTerms, c.status]
    .filter(Boolean)
    .join(' ')
    .toLowerCase();
}

export function jobDisplayLabel(j) {
  if (!j) return '';
  const title = (j.title || '').trim() || j.id || '';
  return j.id && title !== j.id ? `${title} (${j.id})` : title;
}

export function jobSearchText(j) {
  return [j.title, j.id, j.clientName, j.clientId, j.location, j.status, j.recruiterName, j.recruiterId]
    .filter(Boolean)
    .join(' ')
    .toLowerCase();
}

export function recruiterDisplayLabel(r) {
  if (!r) return '';
  const name = (r.name || '').trim();
  const email = (r.email || '').trim();
  if (name && email) return `${name} (${email})`;
  return name || email || r.id || '';
}

export function recruiterSearchText(r) {
  return [r.name, r.email, r.phone, r.id, r.status].filter(Boolean).join(' ').toLowerCase();
}

/** { value, label } rows used in filter bars */
export function optionSearchText(o) {
  return `${o.label || ''} ${o.value || ''}`.trim().toLowerCase();
}
